export const DEFAULT_PHASE_LABEL = 'Phase 1';
export const PHASE_LABEL_LIMIT = 80;

/** Missing labels belong to legacy posters; an explicit blank hides the label. */
export function phaseLabel(meta: { phase_label?: string | null }): string {
  return meta.phase_label ?? DEFAULT_PHASE_LABEL;
}
